@import 'ui-cms-flipcard-group';
/* stylelint-disable declaration-no-important */
@mixin default-item-styles {
  ui-cms-flipcard[bars-visible] {
    margin-top: 80px;
  }

  div.mgnlEditorBar {
    margin-top: 60px !important;
    /* stylelint-disable-next-line function-no-unknown */
    margin-left: gutter() !important;
    /* stylelint-disable-next-line function-no-unknown */
    margin-right: gutter() !important;
    top: -35px;
  }
}

ui-cms-flipcard-group {
  display: block;

  ui-cms-flipcard[bars-visible] {
    margin-top: 15px;
  }

  div.mgnlEditorBar {
    margin-top: 30px !important;
    width: 100% !important;
  }

  &[columns='2'],
  &[columns='3'] {
    div.mgnlEditorBar.area {
      width: 100% !important;
    }

    @include breakpoint($small) {
      @include default-item-styles();

      [bars-visible] {
        /* stylelint-disable-next-line function-no-unknown */
        margin-left: -1 * span(6);
      }

      div.mgnlEditorBar {
        /* stylelint-disable-next-line function-no-unknown */
        width: calc(#{span(6)} - #{2 * gutter()}) !important;
      }
    }
  }

  &[columns='3'] {
    @include breakpoint($medium) {
      [bars-visible] {
        /* stylelint-disable-next-line function-no-unknown */
        margin-left: -1 * span(4);
      }

      div.mgnlEditorBar {
        /* stylelint-disable-next-line function-no-unknown */
        width: calc(#{span(4)} - #{2 * gutter()}) !important;
      }
    }
  }
}
